import FullscriptLogoGreenLeafPigeonTextSVGComponent from "@shared/assets/logo/FullscriptLogoGreenLeafPigeonText";

import * as styles from "./OAuthOnboardingHeader.styles";

interface Props {
  applicationLogo: string;
}

const OAuthOnboardingHeader = ({ applicationLogo }: Props) => {
  return (
    <div css={styles.header}>
      <FullscriptLogoGreenLeafPigeonTextSVGComponent css={styles.fsLogo} />
      <div css={styles.partnerLogoContainer}>
        <img src={applicationLogo} css={styles.partnerLogo} />
      </div>
    </div>
  );
};

export { OAuthOnboardingHeader };
